import { render, staticRenderFns } from "./NewLicense.vue?vue&type=template&id=3fd25a42&"
import script from "./NewLicense.vue?vue&type=script&lang=js&"
export * from "./NewLicense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports